import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHeart, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const location = useLocation();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <nav className="footer-nav">
            <Link 
              to="/" 
              className={`footer-nav-link ${location.pathname === '/' ? 'active' : ''}`}
            >
              Home
            </Link>
            <Link 
              to="/accommodations" 
              className={`footer-nav-link ${location.pathname === '/accommodations' ? 'active' : ''}`}
            >
              Accommodations
            </Link>
            <Link 
              to="/schedule" 
              className={`footer-nav-link ${location.pathname === '/schedule' ? 'active' : ''}`}
            >
              Schedule
            </Link>
            <Link 
              to="/faq" 
              className={`footer-nav-link ${location.pathname === '/faq' ? 'active' : ''}`}
            >
              FAQ
            </Link>
          </nav>
          <div className="footer-details">
            {/* <div className="footer-detail">
              <FaMapMarkerAlt />
              <span>The Surin<br />Phuket, Thailand</span>
            </div> */}
            <div className="footer-detail">
              <FaEnvelope />
              <span>sontyv@gmail.com</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
